export interface InvoiceUnlockRequest {
  companyId: string;
  jobId: string;
  reason: string;
}

/** Same reason limits as the live unlockJobInvoice callable. */
export function invoiceUnlockRequest(companyId: string, jobId: string, reason: string): InvoiceUnlockRequest {
  const cleanReason = reason.trim();
  if (cleanReason.length < 3 || cleanReason.length > 500) {
    throw new Error('Enter a reason between 3 and 500 characters.');
  }
  return { companyId, jobId, reason: cleanReason };
}
